export default "__VITE_ASSET__trUT53I___";